module.exports = __webpack_public_path__ + "img/icon_5_89.f94f94cf.png";